import React from "react";
import { Typography, Box, ListItem, Button, Tooltip } from "@mui/material";
import { HeldIcon, PerformingIcon, ReadyPerformIcon } from "./StaticData/index";
import ProgressMeeting from "../LComponents/ProgressMeeting/ProgressMeeting";
import DyStyledBadge from "../../../components/GlobalComponents/DyStyledBadge/DyStyledBadge";
import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { baseUrl } from "../../../env"
import {
  useGetTeamsByTenantId,
  UseGetWebCheckinMeetingDetailsByMeetingId,
} from "../Hooks/index";
import { useState, useEffect } from "react";
import * as moment from "jalali-moment";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setMeetingIdR } from "../MeetingsSlice/MeetingsSlice";
import { setInitialTreeViewR } from "../../Meeting/MeetingsSlice/MeetingsSlice";
import { IconButton } from "@mui/material";
import Exeloo from "../MeetingCard/StaticData/Svg/exeloo.svg";
import EditIcon from "@mui/icons-material/Edit";
import { useDeleteMeeting, useEditMeeting } from "../Hooks/index";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const MyMeetingCard = ({
  info,
  setMeetId,
  setDeleteMeetState,
  prog,
  setShowToastMessage,
  bank,
  accessForReport,
  setShowDownlodLink,
  setPMeetingId,
  setshowEditMeeting,
}: any) => {
  const userId = useSelector((state: any) => state.loign.userInfo.userId);
  const tenantId: any = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
//   const [deleteIds, setDeleteIds] = useState<any>();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [meetingId, setMeetingId] = useState<string>("");
  const getDetSuccess = () => {
    navigate("/myCompanyTeams", { replace: true });
  };
  const getDetFailed = () => {};

  const LoginMeeting = async () => {
    try {
      dispatch(setInitialTreeViewR());
      let { meetingDate, id } = info;
      setMeetingId(id);
      setMeetId(id);
      let meetDetail = {
        id: id,
        meetingDate: meetingDate,
      };
      dispatch(setMeetingIdR(meetDetail));
    } catch (error) {
    }
  };
  const { mutate: deleteMeeting ,isError,isSuccess,data:deleteData} = useDeleteMeeting();
  const initialDeleteMeeting = () => {
    let { id } = info;
    let ids = {
      tenantId: tenantId,
      userId: userId,
      deletedId: id,
    };
    deleteMeeting(ids);
    handleClose();
  };
  useEffect(() => {
    if (deleteData) {
      setShowToastMessage(true);
      setDeleteMeetState(deleteData?.data)
    }
  }, [isSuccess,deleteData])

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card sx={{ width: "100%", boxShadow: 6, borderRadius: 5 }}>
      <CardContent>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            columnGap={1}
          >
            <Typography fontWeight={900} fontSize={"18px"}>
              {info?.meetingDate}
            </Typography>
          </Box>
          <Box
            width={"100px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Typography
              fontWeight={900}
              variant="caption"
              py={1}
              textAlign={"center"}
              width={"80px"}
              color={"primary"}
              border={2}
              borderColor={"00387C"}
              borderRadius={1}
            >
              {info?.name}
            </Typography>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"row-reverse"}
            justifyContent={"left"}
          >
                        <Box>
            <Tooltip  title="ویرایش">
            <IconButton
              onClick={() => {
                let { id } = info;
                setPMeetingId(id);
                setshowEditMeeting(true);
              }}
            >
              <EditIcon color="primary" />
            </IconButton>
            </Tooltip>
            </Box>
<Box>
            <Tooltip  title="حذف">
        <IconButton  onClick={handleClickOpen}>
        <DeleteIcon color='error'   />
       </IconButton>
       </Tooltip>
       <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
          {"آیا از حذف جلسه اطمینان دارید؟"}
        </DialogTitle>
        <DialogActions >
          <Button autoFocus onClick={handleClose} >
            <Typography  color={'red'}> انصراف</Typography>
          </Button>
          <Button onClick={() => {initialDeleteMeeting();}} autoFocus>
            <Typography  color={'#00387C'} > تایید</Typography>
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
          </Box>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={"row-reverse"}
          py={1}
        >
          <Box display={"flex"} justifyContent={"space-between"}>
            <Typography sx={{ fontSize: "13px" }}>{info.status}</Typography>
            <Typography sx={{ fontSize: "13px" }}>
              {info.MeetingNumber}
            </Typography>
          </Box>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            columnGap={1}
            alignItems={"center"}
          >
            <Typography color={"black"}>
              از {info?.fromTime} تا {info?.toTime}
            </Typography>
          </Box>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            {info.type == 1 && <HeldIcon />}
            {info.type == 2 && (
              <Box px={1}>
                <DyStyledBadge />
              </Box>
            )}
            {info.type == 3 && <ReadyPerformIcon />}
          </Box>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography fontWeight={900} fontSize={"13px"}>
              {info?.meetingNumber}
            </Typography>
          </Box>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="button" color="gray">
            {info.level}
          </Typography>
        </Box>
        <Box minHeight={"50px"}>
          {info?.definitionLevel.length > 110 ? (
            <Tooltip
              sx={{ fontSize: "1.5rem !important" }}
              title={info?.definitionLevel}
            >
              <Typography
                sx={{
                  fontSize: "12px !important",
                  color: "black",
                  cursor: "pointer",
                  textAlign: "left",
                }}
              >
                {info?.definitionLevel.slice(0, 110)}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              sx={{
                fontSize: "12px !important",
                color: "black",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {info?.definitionLevel}
            </Typography>
          )}
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row-reverse"}
          justifyContent={"space-between"}
        >
          <Box
            marginTop={1}
            display={"flex"}
            justifyContent={"center"}
            bgcolor={"#00387C"}
            borderRadius={2}
            maxHeight={"25px"}
            width={"95px"}
          >
            <Button
              variant="text"
              onClick={() => {
                LoginMeeting();
              }}
            >
              <Typography color={"white"} fontSize={"12px"}>
                ورود به جلسه
              </Typography>
            </Button>
          </Box>
          <Box display={"flex"} justifyContent={"center"}>
          <Tooltip title="تعداد نظرات ثبت شده">
            <Box display={"flex"} justifyContent={"center"}
            width={31} height={31} marginTop={1}
             borderRadius={100} color={"white"} alignItems={"center"} bgcolor={"#00387C"}>
            {info?.commentCount}
            </Box>
          </Tooltip>
          </Box>
          <Box display={"flex"} justifyContent={"center"}>
            {accessForReport && (
              <Box display={"flex"} justifyContent={"center"}>
                <IconButton
                  color="info"
                  onClick={() => {
                    let { id } = info;
                    setMeetingId(id);
                  }}
                >
                  <Box>
                    <Link
                      target="_blank"
                      to={`${baseUrl}Download/ExportMeetingDetails?meetingId=${meetingId}`}
                    >
                      <img
                        src={Exeloo}
                        style={{ height: 28, width: 30 }}
                        alt="exelLogo"
                      />
                    </Link>
                  </Box>
                </IconButton>
              </Box>
            )}
          </Box>
          <Tooltip title="درصد ارزیابی KR">
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
              <ProgressMeeting prog={info?.evaluationPercentage} />
            </Box>
          </Tooltip>
          {bank && (
            <Tooltip title="درصد ارزیابی BAU">
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <ProgressMeeting prog={info?.evaluationPercentageBau} />
            </Box>
          </Tooltip>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default MyMeetingCard;
